import { useState } from "react";
import { ChevronDown, Menu, X, Plane, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND_DOMAIN } from "@/constants/Brand";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: "Descubre", hasDropdown: true },
    { label: "Mis viajes", hasDropdown: true },
    { label: "Centro de ayuda", hasDropdown: false },
  ];

  const rightNavItems = [
    { label: "Estado de vuelo", href: "#" },
    { label: "AeroPass", href: "#", isExternal: true },
  ];

  return (
    <header className="nav-gradient text-primary-foreground sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center lg:justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center gap-2 group">
            <img src="logo_horizontal.svg" alt={BRAND_DOMAIN} width={253} height={60}></img>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-primary border-t border-white/10 animate-fade-in">
          <nav className="container mx-auto px-4 py-4 space-y-2">
            {navItems.map((item) => (
              <button
                key={item.label}
                className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium hover:bg-white/10 rounded-lg transition-colors"
              >
                {item.label}
                {item.hasDropdown && <ChevronDown className="w-4 h-4" />}
              </button>
            ))}
            <div className="border-t border-white/10 pt-4 mt-4 space-y-2">
              {rightNavItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="flex items-center gap-2 px-4 py-3 text-sm font-medium hover:bg-white/10 rounded-lg transition-colors"
                >
                  {item.label}
                  {item.isExternal && <ExternalLink className="w-3 h-3" />}
                </a>
              ))}
            </div>
            <Button
              variant="secondary"
              className="w-full bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold rounded-full mt-4"
            >
              Iniciar sesión
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
